<div class="wrapper">
  <div class="header">
    <ng-content></ng-content>
  </div>
  <div class="body">
    <app-survey-frame-list>
      <app-survey-frame-list-template
        [index]="i"
        *ngFor="let building of buildings; let i = index"
        [formGroup]="technicalInfoForms[building.id]"
        [id]="building.id"
      >
        <div class="templateHeader" header>
          <div class="header-part">
            <ng-container *ngIf="!inPortrait; else keysPortrait">
              <div
                style="padding: 0; margin-right: 0.5rem"
                class="vertical-flex"
              >
                <mat-icon *ngIf="getErrors(building?.id)" style="color: red"
                  >warning
                </mat-icon>
              </div>
              <div class="vertical-flex">
                <span class="bold">
                  <span i18n="@@survey.inside.outside.technicalinfo.building"
                    >Building</span
                  >
                  <span> {{ i + 1 }}</span>
                </span>
                <span>{{ building?.lomKey ?? "-" }}</span>
              </div>
            </ng-container>
            <ng-template #keysPortrait>
              <div
                style="padding: 0; margin-right: 0.5rem"
                class="vertical-flex portrait"
              >
                <mat-icon *ngIf="getErrors(building?.id)" style="color: red"
                  >warning
                </mat-icon>
              </div>
              <div class="vertical-flex portrait">
                <span
                  ><span class="bold">B{{ i + 1 }}</span> -
                  <span class="small">{{ building?.lomKey ?? "" }}</span></span
                >
              </div>
            </ng-template>
          </div>
          <div class="header-part">
            <div class="vertical-flex">
              <div style="justify-content: left">
                <span class="address">
                  {{ building?.getMainAddress()?.getFullAddress() }}</span
                >
                <div>
                  <span class="bold">X:</span>
                  {{ building.getMiddleCoordinate()?.posX }}
                  <span class="bold">Y:</span>
                  {{ building.getMiddleCoordinate()?.posY }}
                </div>
              </div>
            </div>
          </div>
          <div class="header-part grow"></div>
          <div
            class="header-part no-wrap"
            *ngIf="
              hasFrontYard(building.id) ||
              hasSolutionDoubt(building.id)
            "
          >          
            <span class="photo-count"            
              ><span
                *ngIf="hasFrontYard(building.id)"
                [class.red-count]="
                  !building.outsideSurvey.photos.frontYardPhotos.length
                "
                >{{
                  building.outsideSurvey.photos.frontYardPhotos.length ?? 0
                }}</span
              >
              <span
                *ngIf="
                  hasFrontYard(building.id) &&
                  hasSolutionDoubt(building.id)
                "
              >
                |
              </span>
              <span
                *ngIf="hasSolutionDoubt(building.id)"
                >{{
                  building.outsideSurvey.photos.solutionDoubtPhotos.length ?? 0
                }}</span
              ></span
            >
          </div>
          <div class="header-part">
            <div
              class="circle"
              *ngIf="building?.getMainAddress()?.isMainAddress"
            >
              <mat-icon class="material-icons-outlined"> home </mat-icon>
            </div>
          </div>
        </div>
        <div detail>
          <div class="holder">
            <div
              style="display: flex; align-items: center; gap: 1rem"
              class="sub-title required"
            >
              <mat-icon
                *ngIf="
                  getErrors(
                    building.id,
                    InsideSurveyOutsideInfoEnum.HEAD_OF_DISTRIBUTION_SUBTITLE
                  )
                "
                style="color: red"
                >warning
              </mat-icon>
              <span
                i18n="@@survey.inside.outside.technicalinfo.headofdistribution"
                >Head of distribution</span
              >
            </div>
            <div class="section">
              <div class="questions">
                <div class="form-line">
                  <app-technical-info-question
                    [question]="'Type'"
                    formControlName="mainDistribution"
                    [options]="mainDistributionTypeOptions"
                    [class.disabled]="!isMainDistributionEditable"
                    [displayError]="
                      getErrors(
                        building.id,
                        InsideSurveyOutsideInfoEnum.HEAD_OF_DISTRIBUTION_SUBTITLE,
                        InsideSurveyOutsideInfoEnum.MAIN_DISTRIBUTION_TYPE_FIELD
                      )
                    "
                  >
                  </app-technical-info-question>
                </div>
                <div
                  class="form-line"
                  *ngIf="
                    getMainDistributionType(building.id) ==
                    outsideTechnicalInfoMainDistributionType.Gevel
                  "
                >
                  <div class="question required subtitle-wrapper">
                    <mat-icon
                      style="color: red"
                      *ngIf="
                        getErrors(
                          building.id,
                          InsideSurveyOutsideInfoEnum.HEAD_OF_DISTRIBUTION_SUBTITLE,
                          InsideSurveyOutsideInfoEnum.FACADE_HEIGHT_FIELD
                        )
                      "
                      >warning
                    </mat-icon>
                    <span
                      i18n="
                        @@survey.inside.outside.technicalinfo.question.facade.height"
                    >
                      Facade height (m)
                    </span>
                  </div>
                  <div
                    class="input-wrapper height-input"
                    [ngClass]="{
                      'invalid-answer-input': getErrors(
                        building.id,
                        InsideSurveyOutsideInfoEnum.HEAD_OF_DISTRIBUTION_SUBTITLE,
                        InsideSurveyOutsideInfoEnum.FACADE_HEIGHT_FIELD
                      )
                    }"
                  >
                    <input
                      type="number"
                      (keypress)="_numService.preventNonNumericalInput($event)"
                      formControlName="mainDistributionHeight"
                      class="form-control"
                      [class.disabled]="!isMainDistributionEditable"
                    />
                  </div>
                </div>
                <div
                  class="form-line"
                  *ngIf="
                    getMainDistributionType(building.id) ==
                    outsideTechnicalInfoMainDistributionType.Ondergronds
                  "
                >
                  <div class="question required subtitle-wrapper">
                    <mat-icon
                      style="color: red"
                      *ngIf="
                        getErrors(
                          building.id,
                          InsideSurveyOutsideInfoEnum.HEAD_OF_DISTRIBUTION_SUBTITLE,
                          InsideSurveyOutsideInfoEnum.UNDERGROUND_REASON_FIELD
                        )
                      "
                      >warning
                    </mat-icon>
                    <span
                      i18n="
                        @@survey.inside.outside.technicalinfo.question.underground.reason"
                    >
                      Underground reason
                    </span>
                  </div>
                  <div
                    class="select-wrapper"
                    [ngClass]="{
                      'invalid-answer-input': getErrors(
                        building.id,
                        InsideSurveyOutsideInfoEnum.HEAD_OF_DISTRIBUTION_SUBTITLE,
                        InsideSurveyOutsideInfoEnum.UNDERGROUND_REASON_FIELD
                      )
                    }"
                  >
                    <p-dropdown
                      [options]="mainDistributionUndergroundReasonOptions"
                      formControlName="mainDistributionUndergroundReason"
                      optionLabel="label"
                      optionValue="value"
                      placeholder="_"
                      [class.disabled]="!isMainDistributionEditable"
                    ></p-dropdown>
                  </div>
                </div>
                <div class="form-line">
                  <app-technical-info-question
                    [question]="frontyard"
                    formControlName="frontYard"
                    [options]="mainDistributionBoolOption"
                    [isDisabled]="!isAuthCanWrite"
                    [displayError]="
                      getErrors(
                        building.id,
                        InsideSurveyOutsideInfoEnum.HEAD_OF_DISTRIBUTION_SUBTITLE,
                        InsideSurveyOutsideInfoEnum.FRONT_YARD_FIELD
                      )
                    "
                  >
                  </app-technical-info-question>
                </div>
                <div *ngIf="hasFrontYard(building.id)">
                  <div class="form-line">
                    <div class="question required subtitle-wrapper">
                      <mat-icon
                        style="color: red"
                        *ngIf="
                          getErrors(
                            building.id,
                            InsideSurveyOutsideInfoEnum.HEAD_OF_DISTRIBUTION_SUBTITLE,
                            InsideSurveyOutsideInfoEnum.LENGTH_FRONT_YARD_FIELD
                          )
                        "
                        >warning
                      </mat-icon>
                      <span
                        i18n="
                          @@survey.inside.outside.technicalinfo.question.frontyard.length"
                      >
                        Length front yard (m)
                      </span>
                    </div>
                    <div
                      class="input-wrapper height-input"
                      [ngClass]="{
                        'invalid-answer-input': getErrors(
                          building.id,
                          InsideSurveyOutsideInfoEnum.HEAD_OF_DISTRIBUTION_SUBTITLE,
                          InsideSurveyOutsideInfoEnum.LENGTH_FRONT_YARD_FIELD
                        )
                      }"
                    >
                      <input
                        type="number"
                        (keypress)="
                          _numService.preventNonNumericalInput($event)
                        "
                        formControlName="mainDistributionFrontYardLength"
                        class="form-control"
                        placeholder=""
                        [class.disabled]="!isAuthCanWrite"
                      />
                    </div>
                  </div>
                  <div class="form-line">
                    <div class="question required subtitle-wrapper">
                      <mat-icon
                        style="color: red"
                        *ngIf="
                          getErrors(
                            building.id,
                            InsideSurveyOutsideInfoEnum.HEAD_OF_DISTRIBUTION_SUBTITLE,
                            InsideSurveyOutsideInfoEnum.FRONT_YARD_PAVEMENT_TYPE_FIELD
                          )
                        "
                        >warning
                      </mat-icon>
                      <span
                        i18n="
                          @@survey.inside.outside.technicalinfo.question.pavement"
                      >
                        Pavement
                      </span>
                    </div>
                    <div
                      class="select-wrapper"
                      [ngClass]="{
                        'invalid-answer-input': getErrors(
                          building.id,
                          InsideSurveyOutsideInfoEnum.HEAD_OF_DISTRIBUTION_SUBTITLE,
                          InsideSurveyOutsideInfoEnum.FRONT_YARD_PAVEMENT_TYPE_FIELD
                        )
                      }"
                    >
                      <p-dropdown
                        [options]="mainDistributionFrontYardPavementOptions"
                        formControlName="mainDistributionFrontYardPavement"
                        optionLabel="label"
                        optionValue="value"
                        placeholder="_"
                      >
                      </p-dropdown>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <ng-container *ngIf="hasFrontYard(building.id)">
              <div class="sub-title">
                <mat-icon
                  style="color: red"
                  *ngIf="
                    getErrors(
                      building.id,
                      InsideSurveyOutsideInfoEnum.FRONT_YARD_PICTURES_SUBTITLE,
                      InsideSurveyOutsideInfoEnum.FRONT_YARD_PICTURES_Field
                    )
                  "
                  >warning
                </mat-icon>
                <span
                  class="sub-title required"
                  i18n="
                    @@survey.inside.outside.technicalinfo.question.frontyard.photo"
                >
                  Frontyard Photo
                </span>
              </div>
              <div class="section photo-section">
                <app-photo-and-remark
                  [surveyId]="building.outsideSurvey.id"
                  [limit]="75"
                  [surveyType]="surveyType.Outside"
                  [surveyPhotoType]="surveyPhotoType.FrontYard"
                  [addressId]="building?.getMainAddress()?.id"
                  [isAuthCanWrite]="isAuthCanWrite"
                  [photos]="building.outsideSurvey.photos.frontYardPhotos"
                  [camera]="camera"
                  [cameraLayer]="cameraLayer"
                  [isInsidePhoto]="false"
                  componentDescriptionTitle="Front Yard"
                ></app-photo-and-remark>
              </div>
            </ng-container>
            <div
              style="display: flex; align-items: center; gap: 1rem"
              class="sub-title required"
            >
              <mat-icon
                *ngIf="
                  getErrors(
                    building.id,
                    InsideSurveyOutsideInfoEnum.FACADE_SUBTITLE
                  )
                "
                style="color: red"
                >warning
              </mat-icon>
              <span i18n="@@general.facade">Facade</span>
            </div>
            <div class="section">
              <div class="questions">
                <div class="form-line">
                  <app-technical-info-question
                    [question]="patrimony"
                    [isDisabled]="!isAuthCanWrite"
                    formControlName="patrimony"
                    [options]="mainDistributionBoolOption"
                    [displayError]="
                      getErrors(
                        building.id,
                        InsideSurveyOutsideInfoEnum.FACADE_SUBTITLE,
                        InsideSurveyOutsideInfoEnum.PATRIMONY_FIELD
                      )
                    "
                  ></app-technical-info-question>
                </div>
                <div class="form-line">
                  <app-technical-info-question
                    [question]="electricityCables"
                    [isDisabled]="!isAuthCanWrite"
                    formControlName="electricityCables"
                    [options]="mainDistributionBoolOption"
                    [displayError]="
                      getErrors(
                        building.id,
                        InsideSurveyOutsideInfoEnum.FACADE_SUBTITLE,
                        InsideSurveyOutsideInfoEnum.ELECTRICITY_CABLES_FIELD
                      )
                    "
                  >
                  </app-technical-info-question>
                </div>
                <div class="form-line">
                  <app-technical-info-question
                    [question]="coaxCables"
                    [isDisabled]="!isAuthCanWrite"
                    formControlName="coaxCables"
                    [options]="mainDistributionBoolOption"
                    [displayError]="
                      getErrors(
                        building.id,
                        InsideSurveyOutsideInfoEnum.FACADE_SUBTITLE,
                        InsideSurveyOutsideInfoEnum.COAX_CABLES_FIELD
                      )
                    "
                  ></app-technical-info-question>
                </div>
                <div class="form-line">
                  <app-technical-info-question
                    [question]="multiTap"
                    [isDisabled]="!isAuthCanWrite"
                    formControlName="multiTap"
                    [options]="mainDistributionBoolOption"
                    [displayError]="
                      getErrors(
                        building.id,
                        InsideSurveyOutsideInfoEnum.FACADE_SUBTITLE,
                        InsideSurveyOutsideInfoEnum.MULTITAP_FIELD
                      )
                    "
                  ></app-technical-info-question>
                </div>
                <div class="form-line">
                  <app-technical-info-question
                    [question]="publicLightning"
                    [isDisabled]="!isAuthCanWrite"
                    formControlName="publicLightning"
                    [options]="mainDistributionBoolOption"
                    [displayError]="
                      getErrors(
                        building.id,
                        InsideSurveyOutsideInfoEnum.FACADE_SUBTITLE,
                        InsideSurveyOutsideInfoEnum.PUBLIC_LIGHTING_FIELD
                      )
                    "
                  >
                  </app-technical-info-question>
                </div>
                <div class="form-line">
                  <mat-icon
                    style="color: red"
                    *ngIf="
                      getErrors(
                        building.id,
                        InsideSurveyOutsideInfoEnum.FACADE_SUBTITLE,
                        InsideSurveyOutsideInfoEnum.FACADE_DOUBTS
                      )
                    "
                    >warning
                  </mat-icon>
                  <app-technical-info-question
                    [question]="solutionDoubt"
                    [isDisabled]="!isAuthCanWrite"
                    formControlName="solutionDoubt"
                    [options]="mainDistributionBoolOption"
                    [displayError]="
                      getErrors(
                        building.id,
                        InsideSurveyOutsideInfoEnum.FACADE_SUBTITLE,
                        InsideSurveyOutsideInfoEnum.FACADE_DOUBTS
                      )
                    "
                  >
                  </app-technical-info-question>
                </div>
                <ng-container *ngIf="hasSolutionDoubt(building.id)">
                  <div class="form-line remarks-line">
                    <textarea
                      formControlName="solutionDoubtRemark"
                      class="remarks"
                      placeholder="Add a comment...*"
                      maxlength="300"
                      [ngClass]="{
                        'invalid-select': getErrors(
                          building.id,
                          InsideSurveyOutsideInfoEnum.FACADE_SUBTITLE,
                          InsideSurveyOutsideInfoEnum.FACADE_DOUBTS_REMARK
                        )
                      }"
                    ></textarea>
                  </div>
                </ng-container>
              </div>

              <div class="sub-title" i18n="@@general.facade.remarks">
                Facade remarks
              </div>
              <div class="remarks">
                <textarea
                  placeholder="Add a comment..."
                  [readonly]="!isAuthCanWrite"
                  formControlName="facadeRemark"
                >
                </textarea>
              </div>
            </div>
            <ng-container *ngIf="hasSolutionDoubt(building.id)">
              <div
                class="sub-title"
                i18n="@@survey.outside.technical.facade.doubts"
              >
                Façade doubts
              </div>
              <div class="section photo-section">
                <app-photo-and-remark
                  [surveyId]="building.outsideSurvey.id"
                  [limit]="75"
                  [surveyType]="surveyType.Outside"
                  [surveyPhotoType]="surveyPhotoType.SolutionDoubt"
                  [addressId]="building?.getMainAddress()?.id"
                  [isAuthCanWrite]="isAuthCanWrite"
                  [photos]="building.outsideSurvey.photos.solutionDoubtPhotos"
                  [camera]="camera"
                  [cameraLayer]="cameraLayer"
                  [isInsidePhoto]="false"
                  componentDescriptionTitle="Facade Doubts"
                >
                </app-photo-and-remark>
              </div>
            </ng-container>
            <div
              style="display: flex; align-items: center; gap: 1rem"
              class="sub-title required"
            >
              <mat-icon
                *ngIf="
                  getErrors(
                    building.id,
                    InsideSurveyOutsideInfoEnum.STREET_SUBTITLE
                  )
                "
                style="color: red"
                >warning
              </mat-icon>
              <span i18n="@@general.street">Street</span>
            </div>
            <div class="section">
              <div class="questions">
                <div class="form-line">
                  <mat-icon
                    style="color: red"
                    *ngIf="
                      getErrors(
                        building.id,
                        InsideSurveyOutsideInfoEnum.STREET_SUBTITLE,
                        InsideSurveyOutsideInfoEnum.STREET_FURNITURE_QUESTION_FIELD
                      )
                    "
                    >warning
                  </mat-icon>
                  <app-technical-info-question
                    [question]="streetFurniture"
                    [isDisabled]="!isAuthCanWrite"
                    formControlName="streetFurniture"
                    [options]="mainDistributionBoolOption"
                    [displayError]="
                      getErrors(
                        building.id,
                        InsideSurveyOutsideInfoEnum.STREET_SUBTITLE,
                        InsideSurveyOutsideInfoEnum.STREET_FURNITURE_QUESTION_FIELD
                      )
                    "
                  >
                  </app-technical-info-question>
                </div>
                <div
                  class="form-line multi-select-line"
                  *ngIf="hasStreetFurniture(building.id)"
                >
                  <div class="question">
                    <mat-icon
                      style="color: red"
                      *ngIf="
                        getErrors(
                          building.id,
                          InsideSurveyOutsideInfoEnum.STREET_SUBTITLE,
                          InsideSurveyOutsideInfoEnum.STREET_FURNITURE_FIELD
                        )
                      "
                      >warning
                    </mat-icon>
                    <span
                      class="question required"
                      i18n="
                        @@survey.inside.outside.technicalinfo.question.streetfurniture"
                      >Street Furniture type</span
                    >
                  </div>
                  <div
                    class="multi-select-wrapper"
                    *ngIf="hasStreetFurniture(building.id)"
                  >
                    <div class="select-options">
                      <p-checkbox
                        [formControl]="
                          technicalInfoForms[building.id].controls[
                            'streetFurnitureTypes'
                          ]
                        "
                        *ngFor="let option of streetFurnitureTypeOptions"
                        [label]="option.label"
                        [value]="option.value"
                        [ngClass]="{
                          'invalid-answer-checkbox': getErrors(
                            building.id,
                            InsideSurveyOutsideInfoEnum.STREET_SUBTITLE,
                            InsideSurveyOutsideInfoEnum.STREET_FURNITURE_FIELD
                          )
                        }"
                      >
                      </p-checkbox>
                    </div>
                  </div>
                </div>

                <div class="form-line">
                  <mat-icon
                    style="color: red"
                    *ngIf="
                      getErrors(
                        building.id,
                        InsideSurveyOutsideInfoEnum.STREET_SUBTITLE,
                        InsideSurveyOutsideInfoEnum.OTHER_OBSTRUCTION_QUESTION_FIELD
                      )
                    "
                    >warning
                  </mat-icon>
                  <app-technical-info-question
                    [question]="otherObstruction"
                    [isDisabled]="!isAuthCanWrite"
                    formControlName="otherObstruction"
                    [options]="mainDistributionBoolOption"
                    [displayError]="
                      getErrors(
                        building.id,
                        InsideSurveyOutsideInfoEnum.STREET_SUBTITLE,
                        InsideSurveyOutsideInfoEnum.OTHER_OBSTRUCTION_QUESTION_FIELD
                      )
                    "
                  >
                  </app-technical-info-question>
                </div>
                <div
                  class="form-line multi-select-line"
                  *ngIf="hasOtherObstruction(building.id)"
                >
                  <div
                    class="question"
                    style="display: flex; align-items: center; gap: 1rem"
                  >
                    <mat-icon
                      style="color: red"
                      *ngIf="
                        getErrors(
                          building.id,
                          InsideSurveyOutsideInfoEnum.STREET_SUBTITLE,
                          InsideSurveyOutsideInfoEnum.OTHER_OBSTRUCTION_FIELD
                        )
                      "
                      >warning
                    </mat-icon>
                    <span
                      class="question required"
                      i18n="
                        @@survey.inside.outside.technicalinfo.question.facade.obstructiontype"
                      >facade obstructions type</span
                    >
                  </div>
                  <div
                    class="multi-select-wrapper"
                    *ngIf="hasOtherObstruction(building.id)"
                  >
                    <div class="select-options">
                      <p-checkbox
                        [formControl]="
                          technicalInfoForms[building.id].controls[
                            'otherObstructionTypes'
                          ]
                        "
                        *ngFor="let option of otherObstructionTypeOptions"
                        [label]="option.label"
                        [value]="option.value"
                        [ngClass]="{
                          'invalid-answer-checkbox': getErrors(
                            building.id,
                            InsideSurveyOutsideInfoEnum.STREET_SUBTITLE,
                            InsideSurveyOutsideInfoEnum.OTHER_OBSTRUCTION_FIELD
                          )
                        }"
                      ></p-checkbox>
                    </div>
                  </div>
                </div>
                <div class="form-line">
                  <div
                    class="question"
                    style="display: flex; align-items: center; gap: 1rem"
                  >
                    <mat-icon
                      style="color: red"
                      *ngIf="
                        getErrors(
                          building.id,
                          InsideSurveyOutsideInfoEnum.STREET_SUBTITLE,
                          InsideSurveyOutsideInfoEnum.PAVING_FOOTPATH_FIELD
                        )
                      "
                      >warning
                    </mat-icon>
                    <span
                      class="question required"
                      i18n="
                        @@survey.inside.outside.technicalinfo.question.pavement.footpath"
                    >
                      Type of paving footpath
                    </span>
                  </div>
                  <div
                    class="select-wrapper"
                    [ngClass]="{
                      'invalid-answer-input': getErrors(
                        building.id,
                        InsideSurveyOutsideInfoEnum.STREET_SUBTITLE,
                        InsideSurveyOutsideInfoEnum.PAVING_FOOTPATH_FIELD
                      )
                    }"
                  >
                    <p-dropdown
                      [options]="pavingFootpathTypeOptions"
                      formControlName="pavingFootpath"
                      optionLabel="label"
                      optionValue="value"
                      placeholder="_"
                    ></p-dropdown>
                  </div>
                </div>
                <!-- <app-technical-info-question [question]="'Sierbestrating voetpad'" formControlName="pavingFootpath" [options]="mainDistributionBoolOption"></app-technical-info-question> -->
              </div>

              <div class="sub-title" i18n="@@general.street.remarks">
                Street remarks
              </div>

              <div class="remarks">
                <textarea
                  placeholder="Add a comment..."
                  [readonly]="!isAuthCanWrite"
                  formControlName="streetRemark"
                >
                </textarea>
              </div>
            </div>

            <div class="sub-title" i18n="@@general.general">General</div>
            <div class="section remarks-section">
              <div class="remarks">
                <textarea
                  placeholder="Add a comment..."
                  [readonly]="!isAuthCanWrite"
                  formControlName="generalBuildingRemark"
                >
                </textarea>
              </div>
            </div>
          </div>
        </div>
      </app-survey-frame-list-template>
    </app-survey-frame-list>
  </div>
  <div class="open-all-btn-wrapper">
    <div
      *ngIf="showOpenButton$ | async; else collapseBtn"
      class="open-all-btn"
      (click)="openAllFrames()"
    >
      <mat-icon>launch</mat-icon>
    </div>
    <ng-template #collapseBtn>
      <div class="open-all-btn" (click)="closeAllFrames()">
        <mat-icon class="material-icons-outlined">disabled_by_default</mat-icon>
      </div>
    </ng-template>
  </div>
</div>
